import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { asyncScheduler, Observable, observeOn } from 'rxjs';
import { Version } from '../models/version';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  url?: string;

  private http = inject(HttpClient);

  setBaseURL(baseUrl: string): void {
    this.url = `${baseUrl}/info/version`;
  }

  getBackendVersion(): Observable<Version> {
    if (this.url) {
      return this.http.get<Version>(this.url).pipe(observeOn(asyncScheduler));
    } else {
      throw new Error('Base URL not set');
    }
  }
}
